export default "__VITE_ASSET__314ba315__"